// Portes (Doors and People Test, 1994) — percentile norms by age group
// Tables transcribed from the published norms screenshot.
// null = no published threshold for that (PC, age) cell.
const PCs = [1, 5, 10, 25, 50, 75, 90, 95, 99];

const NORMS = {
  A: {
    "16-31": [6, 9, 10, 11, 12, 12, 12, 12, null],
    "32-47": [6, 8, 10, 11, 12, 12, 12, 12, null],
    "48-64": [null, 9, 9, 10, 11, 12, 12, 12, null],
    "65-79": [null, 7, 8, 9, 11, 12, 12, 12, null],
    "80+":   [null, null, null, 8, 8, null, null, null, 12],
  },
  B: {
    "16-31": [3, 5, 6, 7, 8, 10, 11, 12, null],
    "32-47": [4, 5, 6, 7, 8, 10, 11, 11, null],
    "48-64": [3, 5, 5, 7, 8, 9, 10, 11, null],
    "65-79": [2, 4, 4, 5, 6, 8, 9, 11, 11],
    "80+":   [2, 2, 2, 3, 4, 6, 7, null, 10],
  },
  AB: {
    "16-31": [12, 14, 16, 18, 19, 23, 25, 25, null],
    "32-47": [12, 15, 16, 18, 19, 23, 24, 24, null],
    "48-64": [10, 14, 14, 18, 19, 23, 25, 24, null],
    "65-79": [null, 13, 12, 14, 19, 22, 21, 23, 24],
    "80+":   [null, null, 8, 11, 16, 19, 19, 21, 21],
  },
};

export function getPortesAgeGroup(age) {
  if (age == null || isNaN(age)) return null;
  if (age < 16) return null;
  if (age < 32) return "16-31";
  if (age < 48) return "32-47";
  if (age < 65) return "48-64";
  if (age < 80) return "65-79";
  return "80+";
}

// Returns the PC label for a raw score in {A, B, AB}.
// Rule: highest PC where threshold ≤ raw_score.
// If that PC > 50, output "> 50". Else output "= X" or "< 1".
// Returns the value form ("> 50", "25", "< 1") used by scoringEval and Excel.
export function calcPortesPC(rawScore, age, kind) {
  const ageGroup = getPortesAgeGroup(age);
  if (!ageGroup) return null;
  const thresholds = NORMS[kind]?.[ageGroup];
  if (!thresholds) return null;

  const raw = parseFloat(rawScore);
  if (isNaN(raw)) return null;

  let highestMatched = null;
  for (let i = 0; i < PCs.length; i++) {
    const t = thresholds[i];
    if (t == null) continue;
    if (raw >= t) highestMatched = PCs[i];
  }

  if (highestMatched == null) return "< 1";
  if (highestMatched > 50) return "> 50";
  return String(highestMatched);
}

// Format a stored value (e.g. "> 50", "25", "< 1") as display text "PC> 50" / "PC= 25".
export function formatPortesPC(value) {
  if (value == null || value === "") return null;
  const s = String(value).trim();
  if (s.startsWith(">") || s.startsWith("<")) return `PC${s.startsWith("<") ? "<" : ">"} ${s.replace(/^[<>]\s*/, "")}`;
  return `PC= ${s}`;
}
